import { ActionType, CommandButtonType, DisableReason } from "../../../enums/command-hub/command-buttons";
import DeepPartial from "../../../utils/deep-partial";

export default interface CleaningCommandButton {
  id: string;
  missionId: string | null;
}

export interface CleaningCommandButtonSender {
  type: CommandButtonType;
  action: ActionType;
  missionId: string | null;
  navigatorName: string | null;
  doWallFollow: boolean;
  repeat: number;
  selectedZoneIds: string[];
  selectedLandmarkIds: string[];
  fixedOrder: boolean;
}

export const isCleaningCommandButtonSender = (input: any): input is CleaningCommandButtonSender => {
  return (
    "type" in input &&
    "action" in input &&
    "missionId" in input &&
    "navigatorName" in input &&
    "doWallFollow" in input &&
    "repeat" in input &&
    "selectedZoneIds" in input &&
    "selectedLandmarkIds" in input &&
    "fixedOrder" in input
  );
};

export interface ButtonApiConfiguration {
  button1: string;
  button2: string;
  button3: string;
  button4: string;
  button5: string;
  button6: string;
}

export const getDefaultCleaningCommandButtonSender = (button: Partial<CleaningCommandButtonSender>) =>
  ({
    type: CommandButtonType.ExecuteAction,
    action: ActionType.Clean,
    missionId: null,
    navigatorName: null,
    doWallFollow: false,
    repeat: 1,
    selectedZoneIds: [],
    selectedLandmarkIds: [],
    fixedOrder: false,
    ...button,
  } as CleaningCommandButtonSender);

export interface ActionStatus {
  action: ActionType;
  isEnabled: boolean;
  disableReason: DisableReason | null;
}

export const mapButtonConfigurationApiDataToButtonList = (apiData: ButtonApiConfiguration) => {
  const buttonConfigs: CleaningCommandButton[] = [];
  if (apiData) {
    for (const [id, missionId] of Object.entries(apiData)) {
      buttonConfigs.push({ id, missionId });
    }
  }
  return buttonConfigs;
};

export const mapPartialButtonConfigurationToApi = (buttons: DeepPartial<CleaningCommandButton[]>) =>
  ({
    button1: buttons.find((b) => b?.id === "button1")?.missionId,
    button2: buttons.find((b) => b?.id === "button2")?.missionId,
    button3: buttons.find((b) => b?.id === "button3")?.missionId,
    button4: buttons.find((b) => b?.id === "button4")?.missionId,
    button5: buttons.find((b) => b?.id === "button5")?.missionId,
    button6: buttons.find((b) => b?.id === "button6")?.missionId,
  } as Partial<ButtonApiConfiguration>);

export const mapButtonIdToName = (id: string) =>
  id.replace(/^([a-z])/, (_, c) => c.toUpperCase()).replace(/(\d+)/, "_$1");